module.exports = "<div class=\"wrapper wrapper-content animated fadeInRight\">\r\n    <div class=\"row\">\r\n        <div class=\"col-lg-12\">\r\n            <div class=\"text-center m-t-lg\">\r\n                <img class=\"img-responsive\" style=\"margin: 0 auto;\" src=\"assets/img/landing/underconstruction.jpg\">\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/minor-view/minor-view.template.html
// module id = ../../../../../src/app/views/minor-view/minor-view.template.html
// module chunks = 0